
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M10.43 12.66a.9.9 0 0 1-.5-.16L8 11.1l-1.93 1.4a.89.89 0 0 1-1.4-.74 1 1 0 0 1 0-.29c0-.12.42-1.27.72-2.22L3.55 7.84a.89.89 0 0 1-.38-.73.9.9 0 0 1 .89-.91h2.37L7.15 4a.88.88 0 0 1 1.7 0l.73 2.2H12a.9.9 0 0 1 .89.91.89.89 0 0 1-.38.73l-1.9 1.39c.3.95.68 2.1.72 2.22a1 1 0 0 1 .05.29.9.9 0 0 1-.95.92zm-.19-.85zm-4.48 0zm5.51-.37zm-6.54 0zM8 9.75l.32.23 1.73 1.26c-.12-.38-.33-1-.66-2l-.13-.38.32-.23 1.77-1.3H8.78L8 4.88l-.78 2.41H4.65l1.77 1.3.32.23-.13.38c-.33 1-.54 1.66-.66 2zM11.83 7zM4.17 7z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8 16A8 8 0 0 1 2.34 2.34a8 8 0 0 1 11.32 11.32A8 8 0 0 1 8 16zM8 1.09A6.91 6.91 0 1 0 14.91 8 6.92 6.92 0 0 0 8 1.09z"}})])])])
          )
        }
      }
    